export function createEventBus() {
    const hostListeners = new Map();
    const agentListeners = new Map();
    const bus = {
        onHost(type, handler) {
            const listeners = hostListeners.get(type) ?? new Set();
            listeners.add(handler);
            hostListeners.set(type, listeners);
            return () => listeners.delete(handler);
        },
        emitHost(type, event) {
            for (const listener of agentListeners.get(type) ?? []) {
                listener(event);
            }
        },
    };
    return {
        bus,
        emitToAgent(type, event) {
            for (const listener of hostListeners.get(type) ?? []) {
                listener(event);
            }
        },
        onAgent(type, handler) {
            const listeners = agentListeners.get(type) ?? new Set();
            listeners.add(handler);
            agentListeners.set(type, listeners);
            return () => listeners.delete(handler);
        },
        destroy() {
            hostListeners.clear();
            agentListeners.clear();
        },
    };
}
//# sourceMappingURL=event-bus.js.map